
import LocalizationStore from '../Stores/LocalizationStore'

const ls = LocalizationStore.getInstance()

export function getResetPasswordFormSchema(): any {
    return {
        'title': ls.t!('Reset password'),
        'type': 'object',
        'required': [
            'email'
        ],
        'properties': {
            'email': {
                'title': ls.t('Enter e-mail'),
                'type': 'string',
                'format': 'email'
            }
        }
    }
}

export const UIResetPasswordFormSchema = {
    'email': {
        'ui:widget': 'email'
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/ResetPasswordForm.tsx